import nohoLogo from '../../../../assets/LOGONOHO.gif';

const NOHO_URL = 'https://lovenoho.com/';

// En móvil/táctil confirma antes de salir a la página de NOHO.
// En escritorio abre directo en pestaña nueva.
const handleNohoClick = (event) => {
  let isTouch = false;
  try {
    isTouch = window.matchMedia?.('(pointer: coarse)').matches || 'ontouchstart' in window;
  } catch {
    isTouch = false;
  }
  if (!isTouch) return;
  event.preventDefault();
  const ok = window.confirm('Estás abriendo otra página. ¿Seguro que quieres salir?');
  if (ok) window.open(NOHO_URL, '_blank', 'noopener,noreferrer');
};

/**
 * Crédito de NOHO — logo con link a lovenoho.com.
 *
 * Texto "COLABORACIÓN CON" arriba y logo debajo (apilado vertical).
 *
 * variant="inline": columna centrada y sutil para pies de tarjeta/menú
 *   (MenuOverlay, Panel de ExperienceOverlay). Va en flujo normal
 *   debajo del contenido, no tapa nada.
 * variant="floating": pastilla pequeña y semitransparente para
 *   esquinas libres (GameShell abajo-derecha solo cuando NO se está
 *   jugando). Nunca bloquea inputs del juego.
 * variant="footer": pie centrado para la parte inferior del mapa (hub).
 *   Opaco y en grises; toma color al pasar el mouse. En móvil pregunta
 *   antes de salir a la página externa.
 */
export default function NohoCredit({ variant = 'inline', className = '' }) {
  if (variant === 'floating') {
    return (
      <a
        href={NOHO_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Colaboración con NOHO — visitar lovenoho.com"
        title="Colaboración con NOHO — lovenoho.com"
        className={`pointer-events-auto inline-flex flex-col items-center gap-1 rounded-2xl border border-white/15 bg-black/60 px-3 py-2 opacity-70 backdrop-blur-sm transition-opacity hover:opacity-100 focus-visible:opacity-100 ${className}`}
      >
        <span className="text-[8px] font-bold uppercase tracking-[.18em] text-white/80">
          Colaboración con
        </span>
        <img
          src={nohoLogo}
          alt="NOHO"
          loading="lazy"
          draggable="false"
          className="h-5 w-auto max-w-[72px] object-contain"
        />
      </a>
    );
  }

  if (variant === 'footer') {
    return (
      <a
        href={NOHO_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleNohoClick}
        aria-label="Desarrollado por NOHO — visitar lovenoho.com"
        title="Desarrollado por NOHO — lovenoho.com"
        className={`pointer-events-auto inline-flex flex-col items-center gap-1 opacity-60 grayscale transition hover:opacity-100 hover:grayscale-0 focus-visible:opacity-100 focus-visible:grayscale-0 ${className}`}
      >
        <span className="text-[8px] font-bold uppercase tracking-[.18em] text-white/75">
          Desarrollado por
        </span>
        <img
          src={nohoLogo}
          alt="NOHO"
          loading="lazy"
          draggable="false"
          className="h-4 w-auto max-w-[64px] object-contain sm:h-5 sm:max-w-[72px]"
        />
      </a>
    );
  }

  return (
    <div className={`flex justify-center ${className}`}>
      <a
        href={NOHO_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Colaboración con NOHO — visitar lovenoho.com"
        title="Colaboración con NOHO — lovenoho.com"
        className="inline-flex min-h-[44px] flex-col items-center gap-1.5 px-3 py-2 opacity-70 transition-opacity hover:opacity-100 focus-visible:opacity-100"
      >
        <span className="text-[9px] font-bold uppercase tracking-[.18em] text-white/60">
          Colaboración con
        </span>
        <img
          src={nohoLogo}
          alt="NOHO"
          loading="lazy"
          draggable="false"
          className="h-7 w-auto max-w-[120px] object-contain"
        />
      </a>
    </div>
  );
}

export { NOHO_URL };
